<span class="flex align-items-center gap-2">
  <i
    [class]="'fas fa-circle'"
    [style]="'color:' + color"
    *ngFor="let color of colorset.colors"></i>
</span>
